import getFirstDescendantWith from './getFirstDescendantWith';

export default (element: Element): Element | undefined =>
  getFirstDescendantWith(element, () => true, 'reverse');
